module.exports = __webpack_public_path__ + "img/key-not-selected.b4834ec2.png";